import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetVolopsPath } from '#/modules/search/volops/routing/searchGetVolopsPath';
import { postAListingPath } from '#/routing/routes';

import type { VolunteerDropdownData } from './types/VolunteerDropdownData';

export const volunteerDropdownDataEs: VolunteerDropdownData = {
  search: {
    title: 'Voluntariado',
    items: [
      {
        type: 'volop',
        title: 'Encontrar Voluntariado',
        href: searchGetVolopsPath({
          locale: I18nLocale.ES,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'post-a-listing',
        title: 'Publicar Voluntariado',
        href: postAListingPath.with({}),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'blog',
        title: 'Blog Idealistas / Voluntariado',
        description:
          'Consejos, recursos para personas voluntarias y gestión de voluntariado en organizaciones.',
        href: '/es/accion?categories=voluntariado&pq=',
      },
    ],
  },
};
